import { ReactNode, useEffect, useState } from 'react';
import UI from './UI';

interface ProgressBarProps {
  count: number;
  capacity: number;
  secondary?: number | null;
  tooltip?: ReactNode;
  brand?: string;
  width?: number | string;
}

const ProgressBar = ({ count, capacity, secondary = 0, tooltip, brand, width }: ProgressBarProps) => {
  const [progress, setProgress] = useState(0);
  const [extra, setExtra] = useState(0);

  const calculatedCapacity = Math.max(capacity, count + secondary);
  const calculatedProgress = Math.min(100, (count / calculatedCapacity) * 100);
  const calculatedExtra = Math.min(100, (secondary / calculatedCapacity) * 100);

  useEffect(() => {
    const timer = window.setTimeout(() => {
      setProgress(calculatedProgress);
      setExtra(calculatedExtra);
    }, 100);

    return () => window.clearTimeout(timer);
  }, [calculatedProgress, calculatedExtra]);

  return (
    <UI.TooltipContainer style={{ width, height: 22, paddingTop: 7, paddingBottom: 7 }}>
      {tooltip && (
        <UI.Tooltip sc={{ alignH: 'center', alignV: 'top', small: true }}>
          {tooltip}
        </UI.Tooltip>
      )}
      <UI.Div
        sc={{ background: 'gray.200' }}
        style={{
          height: '100%', width: '100%', borderRadius: '4px', overflow: 'hidden', display: 'flex',
        }}
      >
        <UI.Div
          sc={{ background: brand || 'success' }}
          style={{
            height: '100%',
            width: `${progress}%`,
            transition: 'all 0.25s ease-in-out',
          }}
        />
        <UI.Div
          sc={{ background: 'info' }}
          style={{
            height: '100%',
            width: `${extra}%`,
            transition: 'all 0.25s ease-in-out',
          }}
        />
      </UI.Div>
    </UI.TooltipContainer>
  );
};

export default ProgressBar;
